import type { BlogPost } from '../types'

import howIFSCoaching from './how-internal-family-systems-coaching-supports-self-discovery'
import ifsVsTherapyArticle from './internal-family-systems-vs-traditional-therapy-whats-the-difference'
import partsWorkProfessionals from './how-parts-work-helps-resolve-inner-conflict-in-high-achieving-professionals'
import signsMayBenefit from './signs-you-may-benefit-from-internal-family-systems-coaching'
import secretInnerAlignment from './the-secret-to-inner-alignment-and-why-most-people-miss-it'
import youDontNeedFixed2 from './you-dont-need-to-be-fixed-you-need-to-be-heard-2'
import whenPartWantsChange from './when-part-of-you-wants-change-and-part-of-you-doesnt'
import getDifferentSides from './how-to-get-the-different-sides-of-you-on-the-same-page'
import makingPeace from './making-peace-with-the-voices-in-your-head'
import innerTugOfWar from './the-inner-tug-of-war-why-you-feel-so-torn-and-what-to-do-about-it'
import whenCantAgree from './when-you-cant-get-yourself-to-agree-with-yourself'
import youDontNeedFixed from './you-dont-need-to-be-fixed-you-need-to-be-heard'
import whyKeepArguing from './why-you-keep-arguing-inside-your-own-head'
import insideIFSSession from './inside-an-ifs-coaching-session-what-to-expect-in-your-first-experience'
import ifsCoachingVsTherapy from './ifs-coaching-vs-ifs-therapy'
import whatIsIFSCoaching from './what-is-ifs-coaching-complete-guide-internal-family-systems-professionals'
import hope from './hope'
import funeralForAFriend from './funeral-for-a-friend'
import competence from './competence'
import challenges from './challenges'
import theReadyPosition from './the-ready-position'
import theSecret from './the-secret'
import eqSelfRegulation from './eq-2-self-regulation'
import procrastination from './procrastination'
import selfActualization from './self-actualization'
import eqSocialAwareness from './eq-3-social-awareness-empathy'
import eqTheProblem from './eq-the-problem'
import flow from './flow'
import quoVadis from './quo-vadis'
import decisions from './decisions'
import eqSelfAwareness from './eq-1-self-awareness'
import empathyExercise1 from './empathy-exercise-1'
import motorcycleSafety from './motorcycle-safety'
import eqRelationshipManagement from './eq-4-relationship-management'
import tellingAHardTruth from './telling-a-hard-truth'
import theLastTime from './the-last-time'
import theMarshmallowTest from './the-marshmallow-test'
import tribal from './tribal'
import theIdealYou from './the-ideal-you'
import overthinking from './overthinking'
import perspective from './perspective'
import letItGo from './let-it-go'
import fallow from './fallow'

const allPosts: BlogPost[] = [
  howIFSCoaching,
  ifsVsTherapyArticle,
  partsWorkProfessionals,
  signsMayBenefit,
  secretInnerAlignment,
  youDontNeedFixed2,
  whenPartWantsChange,
  getDifferentSides,
  makingPeace,
  innerTugOfWar,
  whenCantAgree,
  youDontNeedFixed,
  whyKeepArguing,
  insideIFSSession,
  ifsCoachingVsTherapy,
  whatIsIFSCoaching,
  hope,
  funeralForAFriend,
  competence,
  challenges,
  theReadyPosition,
  theSecret,
  eqSelfRegulation,
  procrastination,
  selfActualization,
  eqSocialAwareness,
  eqTheProblem,
  flow,
  quoVadis,
  decisions,
  eqSelfAwareness,
  empathyExercise1,
  motorcycleSafety,
  eqRelationshipManagement,
  tellingAHardTruth,
  theLastTime,
  theMarshmallowTest,
  tribal,
  theIdealYou,
  overthinking,
  perspective,
  letItGo,
  fallow,
]

export const blog = {
  heading: 'Our Latest Blogs',
  subheading:
    'Explore fresh insights, guidance, and inspiration from our IFS coaching blog to support your personal growth.',
  cta: 'View All',
  posts: allPosts.sort((a, b) => b.date.localeCompare(a.date)),
}
